// extracted by mini-css-extract-plugin
export default {"tag":"FilterTags_tag__By9ae","selected":"FilterTags_selected__nNu5e"};